<div class="white-box main-black mt-4 p-4 border-radius">
	<div class="row mb-4">
		<div class="col">
			<h4>
				{{'utilization.monthly_quarterly_truck_usage_report' | translate}}
			</h4>
		</div>
	</div>

	<ng-container *ngIf="isDeviceShipped !== false; else noData">
	<!-- years list -->
	<div class="col-sm-6 col-md-3 d-inline-flex">
		<ng-select [searchable]="false" class="mr-auto w-100" [items]="yearList" bindLabel="label" bindValue="id" placeholder="{{'site.year' | translate}}" name="year" [(ngModel)]="selectedYear" (ngModelChange)="selectYear()" [clearable]="false">
		</ng-select>
	</div>

	<!-- Monthly or Quarterly drop-down -->
	<div class="col-sm-6 col-md-3 d-inline-flex">
		<ng-select [searchable]="false" class="mr-auto w-100" [items]="periodTypes" bindLabel="label" bindValue="id" placeholder="{{'perf_analytic.period' | translate}}" name="period" [(ngModel)]="selectedPeriodType" (ngModelChange)="changePeriodType()" [clearable]="false">
		</ng-select>
	</div>

	<!-- table -->
	<div class="col-12">
		<sct-custom-table
			#sctCustomTable
			[columnsConfig]="columnConfig"
			[data]="tableData"
			[config]="tableConfig"
		></sct-custom-table>
	</div>
	</ng-container>

	<ng-template #noData>
		<div class="alert alert-info">{{'g.no_data_to_show' | translate}}</div>
	</ng-template>
</div>
